<app-layout [enableTopGap]="true">
  <section class="svc-page">
    <div class="svc-hero">
      <div class="road-hero" aria-hidden="true">
        <div class="road-plane"><span class="road-dashes"></span></div>
      </div>
      <h1 class="svc-title" [appSplitText]="texts.title" splitMode="intro" splitDelay="0.1"></h1>
      <p class="svc-intro" appReveal="rise" revealDelay="0.2">{{ texts.intro }}</p>
    </div>

    <div class="container-fluid">
      <app-package-grid [packages]="cards" variant="services"></app-package-grid>
    </div>
  </section>
</app-layout>
